module.exports = __webpack_public_path__ + "img/chest_coins.aff68bd7.png";